/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 13/12/2020
 */

import {StepType} from "@shared/Program/ProgramStep/helpers/ProgramStepEnums";
import SectionProgramStep from "@shared/Program/ProgramStep/SectionProgramStep";
import NoteProgramStep from "@shared/Program/ProgramStep/NoteProgramStep";
import CoachingSessionStep from "@shared/Program/ProgramStep/CoachingSessionStep";
import TaskProgramStep from "@shared/Program/ProgramStep/TaskProgramStep";
import ContractProgramStep from "@shared/Program/ProgramStep/ContractProgramStep";

export default {
	keepDiscriminatorProperty: true,
	discriminator: {
		property: "stepType",
		subTypes: [
			{ value: SectionProgramStep, name: StepType.SECTION },
			{ value: NoteProgramStep, name: StepType.NOTE },
			{ value: CoachingSessionStep, name: StepType.CALL },
			{ value: TaskProgramStep, name: StepType.TASK },
			{ value: ContractProgramStep, name: StepType.CONTRACT },
		]
	}
}
